<script lang="ts" setup>
import { type PropType } from '#imports';
import type { UserMessageVo } from '@core/types/auto/forum';

defineProps({
  msg: {
    type: Object as PropType<UserMessageVo>,
    default: () => ({}),
  },
});
</script>

<template>
  <div>
    <div v-if="msg.messageType === 2">
      <span class="mr-1 font-semibold">{{ msg.messageContent }}</span>
      <span>回复了你</span>
    </div>
    <div v-else>{{ msg.messageContent }}</div>
  </div>
</template>

<style scoped></style>
